// extracted by mini-css-extract-plugin
export default {"container":"Chronology_container__QyG-F","eventsList":"Chronology_eventsList__N0o9Q","datesList":"Chronology_datesList__ZyXdA","active":"Chronology_active__Msw1t"};